(()=>{
  window.addEventListener('DOMContentLoaded', ()=>{

    document.querySelectorAll('.keyword-search').forEach(keywordSearch => {
      if (keywordSearch.dataset._initKeyword) return;
      keywordSearch.dataset._initKeyword = '1';
      const input = keywordSearch.querySelector('input');
      input.addEventListener('focus', () => {
        keywordSearch.classList.add('--focused');
      })
      input.addEventListener('blur', () => {
        keywordSearch.classList.remove('--focused');
        const input = keywordSearch.querySelector('input');
        keywordSearch.classList.toggle('--active', input.value.split(' ').join('') !== '');
      })

      keywordSearch.querySelectorAll('.__actions button').forEach(button => {
        const action = button.getAttribute('data-action');
        const filterBox = keywordSearch.closest('.__search').querySelector('.search-filter-box');
        if (filterBox) {
          filterBox.callerBtn = button;
          button.addEventListener('click', () => {
            if (action === 'filter') {
              button.classList.toggle('--active');
              filterBox.classList.toggle('--active', button.classList.contains('--active'));
            }
          });
        }
      })
    });
    document.querySelectorAll('.search-filter-box').forEach(filterBox => {
      if (filterBox.dataset._initFilter) return;
      filterBox.dataset._initFilter = '1';
      filterBox.querySelectorAll('button[data-action="close"]').forEach(button => {
        button.addEventListener('click', () => {
          filterBox.classList.remove('--active');
          if (filterBox.callerBtn) filterBox.callerBtn.classList.remove('--active');
        });
      });

      filterBox.querySelectorAll('button[data-action="reset"]').forEach(button => {
        button.addEventListener('click', () => {
          filterBox.querySelectorAll('select, input').forEach(input => {
            // reset select, input
            if (input.type === 'select-one') {
              input.selectedIndex = 0;
            } else if (input.type === 'checkbox' || input.type === 'radio') {
              input.checked = false;
            } else {
              input.value = '';
            }
            input.dispatchEvent(new Event('change', { bubbles: true }));
          })
        });

      })
    })

    document.querySelectorAll('.form-block').forEach(formBlock => {
      initFormBlock(formBlock);
    });

    document.querySelectorAll('.form-block.__phone').forEach(formBlock => {
      if (formBlock.dataset._initPhone) return;
      formBlock.dataset._initPhone = '1';
      const country = formBlock.querySelector('.__country');
    })

    document.querySelectorAll('.form-date:not(.check-range)').forEach(item => {
      if (item.dataset._initDate) return;
      item.dataset._initDate = '1';
      const el = item.querySelector('input[date-picker]');
      const datePicker = new Datepicker(el, {
        autohide: true,
        format:'yyyy/mm/dd',
        beforeShowDay: function(date) {
          date.setHours(0,0,0,0);

          // (기본) 오늘 날짜 강조 클래스 추가
          if (isToday(date)) return { enabled: true, classes: 'today-highlight' };

          // (선택) 주말 비활성화 클래스 추가, 비활성화
          if (item.classList.contains('weekend-disabled')) {
            if (isWeekend(date)) return { enabled: false, classes: 'weekend-disabled' };
          }
          // (선택) 오늘 이후 날짜 비활성화
          if (item.classList.contains('future-disabled')) {
            if (isFutureDate(date)) return { enabled: false };
          }

          return { enabled: true };
        }
      });
      el.addEventListener('changeDate', (e) => {
        el.blur();
      })

      // 직접 입력 가능 요소 이면
      if (item.classList.contains('--text')) {
        el.removeAttribute('readonly') // 직접 입력 시 readonly 삭제
        el.addEventListener('input', (e) => {
          formatDateInput(e.currentTarget); // 직접 입력 시 숫자만 남기고 자동으로 슬래시 삽입

          if (e.currentTarget.value.length >= 10) {
            checkDateInput(e.currentTarget);
            checkDateTodayInput(e.currentTarget);
          }
        })
      }
    });

    window.initCheckRangeFormDate();

    document.querySelectorAll('.form-date-range').forEach(item => {
      if (item.dataset._initRange) return;
      item.dataset._initRange = '1';
      const from = item.querySelector('input[date-from]');
      const to = item.querySelector('input[date-to]');
      const dateRangePicker = new DateRangePicker(from, {
        inputs: [from, to],
        format:'yyyy/mm/dd',
        allowOneSidedRange: true,
      });

      from.addEventListener('changeDate', (e) => {
        from.blur();
      })
      to.addEventListener('changeDate', (e) => {
        to.blur();
      })
    });

    document.querySelectorAll('.form-textarea').forEach(item => {
      if (item.dataset._initTextarea) return;
      item.dataset._initTextarea = '1';
      const total = parseInt(item.querySelector('.__total').textContent);
      const current = item.querySelector('.__current');
      const textarea = item.querySelector('textarea');
      textarea.addEventListener('input', updateChar)
      textarea.addEventListener('updated', updateChar);

      function updateChar() {
        const value = textarea.value;
        const len = value.length;
        if (len > total) {
          textarea.value = value.substring(0, total);
        }
        current.textContent = textarea.value.length;
      }
    })

    document.querySelectorAll('.form-selectbox').forEach(item => {
      window.initFormSelectbox(item);
    })
  })
})();

// form-date check-range 달력 초기화 함수
window.initCheckRangeFormDate = function () {
  document.querySelectorAll('.form-date.check-range').forEach(item => {
    if (item.dataset._initDate) return;
    item.dataset._initDate = '1';

    const el = item.querySelector('input[date-picker]');
    if (!el) return;

    const range = document.querySelector('.form-date-range');
    const fromInput = range?.querySelector('input[date-from]');
    const toInput   = range?.querySelector('input[date-to]');

    // 1) Datepicker 한 번만 생성
    const dp = new Datepicker(el, {
      autohide: true,
      format:'yyyy/mm/dd',
      beforeShowDay: function(date) {
        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());

        if (typeof isToday === 'function' && isToday(d)) return { enabled: true, classes: 'today-highlight' };
        
        // 예약 일정 비활성화
        if (item.classList.contains('reservation-disabled') && isReservationDate(date)) {
          return { enabled: false, classes: 'reservation-disabled' };
        }
        
        if (item.classList.contains('weekend-disabled') && typeof isWeekend === 'function' && isWeekend(d)) {
          return { enabled: false, classes: 'weekend-disabled' };
        }
        if (item.classList.contains('future-disabled') && typeof isFutureDate === 'function' && isFutureDate(d)) {
          return { enabled: false };
        }
        return { enabled: true };
      }
    });

    // 공통: picker 옵션 갱신 (라이브러리별 분기)
    function setMin(date) {
      if (!date) date = null;
      if (typeof dp.setOptions === 'function') dp.setOptions({ minDate: date });
      else if (typeof dp.setStartDate === 'function') dp.setStartDate(date); // bootstrap-datepicker
    }
    function setMax(date) {
      if (!date) date = null;
      if (typeof dp.setOptions === 'function') dp.setOptions({ maxDate: date });
      else if (typeof dp.setEndDate === 'function') dp.setEndDate(date); // bootstrap-datepicker
    }

    // 현재 값이 범위 밖이면 즉시 클램프
    function clampCurrentValue() {
      const cur = parseYmd(el.value);
      const min = parseYmd(fromInput?.value);
      const max = parseYmd(toInput?.value);
      if (!cur) return;

      let clamped = cur;
      if (min && clamped < min) clamped = min;
      if (max && clamped > max) clamped = max;

      if (!sameDay(cur, clamped)) {
        if (typeof dp.setDate === 'function') dp.setDate(clamped, { render: true });
        else el.value = `${clamped.getFullYear()}/${String(clamped.getMonth()+1).padStart(2,'0')}/${String(clamped.getDate()).padStart(2,'0')}`;
      }
    }

    // 2) from/to 변화 시 picker 범위 갱신
    fromInput?.addEventListener('changeDate', () => {
      setMin(parseYmd(fromInput.value));
      clampCurrentValue();
    });
    toInput?.addEventListener('changeDate', () => {
      setMax(parseYmd(toInput.value));
      clampCurrentValue();
    });
    // 사용자가 직접 타이핑하는 경우도 대비
    fromInput?.addEventListener('input', () => {
      setMin(parseYmd(fromInput.value));
      clampCurrentValue();
    });
    toInput?.addEventListener('input', () => {
      setMax(parseYmd(toInput.value));
      clampCurrentValue();
    });

    // 3) 날짜 선택 후 blur
    el.addEventListener('changeDate', () => el.blur());

    // 4) 초기 상태에서도 한 번 적용
    if (fromInput?.value) setMin(parseYmd(fromInput.value));
    if (toInput?.value)   setMax(parseYmd(toInput.value));
    clampCurrentValue();
  });
}


window.initFormBlock = formBlock => {
  if (formBlock.dataset._initFormBlock) return;
  formBlock.dataset._initFormBlock = '1';
  const formInputLength = formBlock.querySelectorAll('.form-control').length;
  formBlock.querySelectorAll('.form-control').forEach(control => {
    const formInput = control.querySelector('.form-input');
    //check formInput is select
    if (formInput.tagName.toUpperCase() === 'SELECT') {
      const isPhoneCode = formInput.classList.contains('--phone-code');
      const formInputWidth = formInput.clientWidth;
      const isTextInput = formInput.classList.contains('--text'); // 직접 입력 가능 input

      formInput.style.opacity = 0;
      formInput.style.position = 'absolute';
      formInput.style.zIndex = -1;
      formInput.style.left = '-9999rem';
      const ghostedInput = document.createElement('input');
      ghostedInput.type = 'text';
      ghostedInput.classList.add('form-input');
      ghostedInput.style.textOverflow = "ellipsis";
      ghostedInput.style.position = 'relative';
      ghostedInput.style.width = (formInputLength  === 1)  ? '100%' : (formInputWidth + 10) + 'px';
      if (isPhoneCode) {
        ghostedInput.style.width = '6em';
      }
      if (!isTextInput) {
        ghostedInput.setAttribute('readonly', 'readonly');
        ghostedInput.style.cursor = 'pointer';
        ghostedInput.tabIndex = -1;
      }
      control.insertBefore(ghostedInput, formInput);

      // SELECT 옵션 가져오기, 빈 값 제외
      let options = Array.from(formInput.querySelectorAll('option'))
        .filter(option => option.value && option.value !== '');

      // --sort 클래스가 있을 때만 오름차순 정렬
      if (formInput.classList.contains('--sort')) {
        options.sort((a, b) => {
          const textA = a.textContent.toUpperCase();
          const textB = b.textContent.toUpperCase();
          if (textA < textB) return -1;
          if (textA > textB) return 1;
          return 0;
        });
      }

      const list = document.createElement('div');
      list.setAttribute('data-lenis-prevent', true);
      list.classList.add('__select-options');
      control.insertBefore(list, formInput);

      // 정렬된 옵션으로 리스트 만들기
      options.forEach(option => {
        const item = document.createElement('div');
        item.classList.add('__option');
        item.setAttribute('data-value', option.value);
        if (isPhoneCode) {
          const code = option.dataset.code;
          if (code) item.setAttribute('data-code', code);
          // 여기 toUpper 없어야 정상
          item.innerHTML = `<span class="__phone-code"><span class="__flag"><img loading="lazy" src="${window.cPath}/assets/img/flags/${code}.svg" alt=""></span> ${option.textContent}</span>`;
        } else {
          item.textContent = option.textContent;
        }

        const pick = () => {
          ghostedInput.value = isPhoneCode ? option.value : option.textContent;
          formInput.value = option.value;
          formInput.dispatchEvent(new Event('change', { bubbles: true }));
          //ghostedInput.blur();
          list.classList.remove('--open'); // 옵션 리스트 닫기
        };
        item.addEventListener('mousedown', pick);
        //item.addEventListener('pointerup', pick, { passive: true });

        list.appendChild(item);
      });
      formInput.addEventListener('updated', () => {
        const value = formInput.value;
        const option = formInput.querySelector(`option[value="${value}"]`);
        ghostedInput.value = option.textContent;
        if (isPhoneCode) {
          ghostedInput.value = option.value;
        }
      });
      // ghostedInput.addEventListener('click', () => {
      //   if (formBlock.classList.contains('--focused')) return;
      //   formInput.focus();
      //   formInput.click();
      // });

      // ghostedInput 클릭 시 옵션 리스트 열기
      ghostedInput.addEventListener('focus', () => {
        control.classList.add('--active', '--focused');
        formBlock.classList.add('--focused');
      });
      ghostedInput.addEventListener('blur', () => {
        control.classList.remove('--focused');
        formBlock.classList.remove('--focused');
        list.classList.remove('--open');
        control.classList.toggle('--has-value', ghostedInput.value.trim() !== '');
        if (ghostedInput.value.trim() == '') {
          control.classList.remove('--active')
        }
      });
      // 입력 시 select 값 업데이트 (일치하는 값 없으면 SELECT는 빈값 유지)
      ghostedInput.addEventListener('input', () => {
        const search = ghostedInput.value.trim().toLowerCase();
        if (search.length > 0) {
          control.classList.add('--has-value');
        } else {
          control.classList.remove('--has-value');
        }
        let hasMatch = false;

        options.forEach(option => {
          let item;
          const optionText = option.textContent.trim().toLowerCase();
          const optionValue = option.value;
          // item 찾기
          if (option.dataset.code) {
            item = list.querySelector(`.__option[data-value="${option.value}"][data-code="${option.dataset.code}"]`);
          } else {
            item = list.querySelector(`.__option[data-value="${option.value}"]`);
          }

          // textContent 기준 필터링
          if (optionText.includes(search) || optionValue.includes(search)) {
            item.style.display = 'flex';
            hasMatch = true;
          } else {
            item.style.display = 'none';
          }
        });

        // select 값 업데이트 (완전히 일치할 경우)
        let match = options.find(opt => opt.textContent.trim().toLowerCase() === search);

        // 전화번호 옵션은 data-code도 고려
        if (!match) {
          match = options.find(opt => opt.dataset.code && opt.textContent.trim().toLowerCase() === search);
        }

        formInput.value = match ? match.value : '';
        formInput.dispatchEvent(new Event('change', { bubbles: true }));

        // 리스트 열기
        if (search.length > 0) {
          list.classList.add('--open');
        } else {
          list.classList.remove('--open');
        }
      });

      if (control.querySelector('.__select-down')) {
        control.querySelector('.__select-down').addEventListener('click', () => {
          if (formBlock.classList.contains('--focused')) return;
          formInput.focus();
          formInput.click();
        });
      }
    }
    formInput.addEventListener('focus', () => {
      control.classList.add('--active');
      control.classList.add('--focused');
      formBlock.classList.add('--focused');
    })
    formInput.addEventListener('blur', () => {
      let isFilled = false;
      if (formInput.value.trim() !== '') {
        isFilled = true;
      }
      if (isFilled === false) {
        control.classList.remove('--active');
      }
      control.classList.remove('--focused');
      formBlock.classList.remove('--focused');
      control.classList.toggle('--has-value', isFilled);
    });
  })
}


window.initFormSelectbox = item => {
  if (item.dataset._initFormSelectbox) return;
  item.dataset._initFormSelectbox = '1';
  const selectbox = item.querySelector('select');
  selectbox.style.opacity = 0;
  selectbox.style.pointerEvents = 'none';
  selectbox.style.position = 'absolute';
  const ghostedInput = document.createElement('div');
  ghostedInput.classList.add('form-input');
  ghostedInput.style.textOverflow = "ellipsis";
  ghostedInput.style.width = '100%';
  item.insertBefore(ghostedInput, selectbox);
  const list = document.createElement('div');
  list.setAttribute('data-lenis-prevent', true);
  list.classList.add('__select-options');
  item.insertBefore(list, selectbox);
  selectbox.querySelectorAll('option').forEach((option, index) => {
    const item = document.createElement('div');
    const value = option.value;
    const isDisabled = option.hasAttribute('disabled') && option.hasAttribute('selected') ;
    if (isDisabled) {
      ghostedInput.textContent = option.textContent;
      return;
    }
    const isSelected = option.hasAttribute('selected');
    if (isSelected) {
      ghostedInput.textContent = option.textContent;
    }
    if (index === 0) {
      ghostedInput.textContent = option.textContent;
    }
    if (value && value !== '') {
      item.classList.add('__option');
      item.textContent = option.textContent;
      item.setAttribute('data-value', option.value);
      item.addEventListener('mousedown', (e) => {
        selectbox.value = option.value;
        selectbox.dispatchEvent(new Event('change', { bubbles: true }));
        onBlur();
      })
      item.addEventListener('pointerup', (e) => {
        selectbox.value = option.value;
        selectbox.dispatchEvent(new Event('change', { bubbles: true }));
        onBlur();
      }, { passive: true });
      list.appendChild(item);
    }
  });


  selectbox.addEventListener('change', () => {
    const value = selectbox.value;
    let option = selectbox.querySelector(`option[value="${value}"]`);
    if(option === null){
      option = selectbox.querySelectorAll('option')[0];
    }
    ghostedInput.textContent = option.textContent;
  });

  ghostedInput.addEventListener('click', () => {
    item.classList.toggle('--focused');
  });

  const onBlur = () => {
    let isFilled = false;
    if (selectbox.value.trim() !== '') {
      isFilled = true;
    }
    if (isFilled === false) {
      item.classList.remove('--active');
    } else {
      item.classList.add('--active');
    }
    item.classList.remove('--focused');
    item.classList.toggle('--has-value', isFilled);
  };


}


window.isValidEmail = (email)=> {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!email || typeof email !== 'string') return false;
  return emailRegex.test(email.trim());
}


window.isValidE164 = (phone) => {
  const e164Regex = /^\+?[1-9]\d{1,14}$/;
  if (!phone || typeof phone !== 'string') return false;
  const normalized = phone.trim().replace(/[\s\-()]/g, ''); // remove spaces, dashes, parens
  return e164Regex.test(normalized);
}

window.isValidKoreanMobile = (phone) => {
  const krMobileRegex = /^(01[016789])[-\s]?\d{3,4}[-\s]?\d{4}$/;
  if (!phone || typeof phone !== 'string') return false;
  return krMobileRegex.test(phone.trim());
}


window.fillValue = (el, value) => {
  if ( el ) {
    el.value = value;
    el.closest('.form-control').classList.add('--active');
    el.closest('.form-control').classList.add('--has-value');
    //trigger el
    el.dispatchEvent(new Event('updated', { bubbles: true }));
    el.blur();
  }
}


window.convertKRW = (str) => {
  return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

window.convertNumber = (str) => {
  return Number(str.toString().replace(/,/g, ''));
}






// 숫자만 남기고 자동으로 슬래시 삽입
window.formatDateInput = (input) => {
  let value = input.value.replace(/[^0-9]/g, "");

  if (value.length >= 5) {
    input.value = value.substring(0, 4) + '/' + value.substring(4, 6) + '/' + value.substring(6, 8);
  } else if (value.length >= 3) {
    input.value = value.substring(0, 4) + '/' + value.substring(4);
  } else {
    input.value = value;
  }
}

// 유효하지 않은 날짜면 경고
window.checkDateInput = (input) => {
  const [y, m, d] = input.value.split('/').map(Number);
  const date = new Date(y, m - 1, d);
  date.setHours(0, 0, 0, 0);

  // 유효한 날짜인지 확인
  if (date.getFullYear() !== y || date.getMonth() + 1 !== m || date.getDate() !== d) {
    alert("Please select a valid date.");
    input.value = "";
  }
}

// 오늘 날짜 이후 체크
window.checkDateTodayInput = (input) => {
  const [y, m, d] = input.value.split('/').map(Number);
  const inputDate = new Date(y, m - 1, d);
  const today = new Date();

  // 시분초 제거 (날짜만 비교)
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  if (inputDate > today) {
    alert("Please select a valid date.");
    input.value = "";
  }
}

const today = new Date();
today.setHours(0, 0, 0, 0);

function isFutureDate(date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // 오늘 날짜 자정으로 설정
  date.setHours(0, 0, 0, 0);   // 입력받은 날짜도 자정으로 설정

  return date > today; // 미래 날짜인지 확인
}

function isWeekend(date) {
  // 입력이 Date 객체로 넘어오므로 바로 처리
  const day = date.getDay();
  return day === 0 || day === 6; // 일요일(0) 또는 토요일(6)일 경우
}

function isToday(date) {
  // 입력이 Date 객체로 넘어오므로 바로 처리
  const today = new Date();
  today.setHours(0, 0, 0, 0); // 오늘 날짜 자정으로 설정
  date.setHours(0, 0, 0, 0);   // 입력받은 날짜도 자정으로 설정

  return date.getTime() === today.getTime(); // 타임스탬프 비교
}

function parseYmd(ymd) {
  if (!ymd) return null;
  const m = String(ymd).trim().match(/^(\d{4})[./-](\d{1,2})[./-](\d{1,2})$/);
  if (!m) return null;
  const d = new Date(+m[1], +m[2]-1, +m[3]);
  return isNaN(d) ? null : d;
}

function sameDay(a,b){
  return a&&b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate();
}

/**
 * 관리자 예약 휴일 jsp 에서 내려준 예약일정 데이터를
 * 달력 beforeShowDay 콜백에서 활용하기 위한 캐시 재구성 및 조회 시작
 */

let reservationDateMap = {};  // 예약 데이터 캐시

// 캐시 재구성 함수
function rebuildReservationCache() {
  if (!Array.isArray(window.reservationDateList)) return;

  reservationDateMap = {}; // reset

  window.reservationDateList.forEach(item => {
    reservationDateMap[item.date] = item.title;
  });
}

// 예약 여부 확인 함수
function isReservationDate(date) {
  const key = `${date.getFullYear()}/${
    String(date.getMonth() + 1).padStart(2, '0')
  }/${
    String(date.getDate()).padStart(2, '0')
  }`;

  // 예약일이면 title 반환, 아니면 null
  return reservationDateMap[key] || null;
}

// JSP에서 이벤트 수신 → 데이터 준비완료
window.addEventListener("reservationDataReady", () => {
  rebuildReservationCache();
  window.initCheckRangeFormDate(); // 예약 휴일 반영
});

/**
 * 관리자 예약 휴일 설정 데이터 처리 끝
 */